import { render, staticRenderFns } from "./expreimburs-adjustfrm.vue?vue&type=template&id=2d0d2be4"
import script from "./expreimburs-adjustfrm.vue?vue&type=script&lang=js"
export * from "./expreimburs-adjustfrm.vue?vue&type=script&lang=js"
import style0 from "./expreimburs-adjustfrm.vue?vue&type=style&index=0&id=2d0d2be4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports